import { AxiosResponse } from 'axios';
import VersionedResource from '../VersionedResource';
import { TransactionClassificationRule } from './TransactionClassificationRule';

export default class TransactionClassificationRuleResource extends VersionedResource {
  public async getAll(fiId: string): Promise<TransactionClassificationRule[]> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/config/${fiId}/transaction-classification-rule`);
    const rules: TransactionClassificationRule[] = response.data.data;
    return rules;
  }

  public async save(fiId: string, rule: TransactionClassificationRule): Promise<TransactionClassificationRule> {
    const url = `/api/rcx/config/${fiId}/transaction-classification-rule`;
    let response: AxiosResponse;

    const toSave: any = {};
    Object.assign(toSave, rule);

    // Text box control will set dollar amount filter to an empty string if cleared out,
    // even though the type is specified as a number, so we must cast to <unknown> to check
    // for that.
    if (<unknown>rule.dollarAmountFilter === '') {
      toSave.dollarAmountFilter = undefined;
    }

    toSave.isSelected = undefined;

    if (rule.id) {
      response = await this.apiClient.put(`${url}/${rule.id}`, toSave);
    } else {
      response = await this.apiClient.post(url, toSave);
    }

    const savedRule: TransactionClassificationRule = response.data.data;
    return savedRule;
  }

  public async remove(fiId: string, ruleId: number): Promise<AxiosResponse> {
    return this.apiClient.delete(`/api/rcx/config/${fiId}/transaction-classification-rule/${ruleId}`);
  }

  public async mergeRules(fiId: string, ruleIds: number[]): Promise<AxiosResponse> {
    return this.apiClient.put(`/api/rcx/config/${fiId}/transaction-classification-rule/`, ruleIds);
  }

  public async refreshPredictions(fiId: string): Promise<AxiosResponse> {
    return this.apiClient.get(`/api/rcx/config/${fiId}/transaction-classification-rule/refresh-predictions`);
  }

  public async getLastPredictionTime(fiId: string): Promise<Date | null> {
    let value: Date | null = null;

    try {
      const response: AxiosResponse = await
      this.apiClient.get(`/api/rcx/config/${fiId}/transaction-classification-rule/last-prediction-time`);
      const valString: string | null = response.data.data.lastGenerated;

      if (valString) {
        value = new Date(`${valString}+0000`);
      }
    } catch (error) {
      // Will 404 if the fi has never been populated
      if (error.response.status !== 404) {
        throw error;
      }
    }
    return value;
  }

  public async copy(destinationFi: string, sourceFi: string): Promise<AxiosResponse> {
    return this.apiClient.post(`/api/rcx/config/${destinationFi}/transaction-classification-rule/copy/${sourceFi}`, {});
  }

  public async importFromUff(fi: string): Promise<AxiosResponse> {
    return this.apiClient.post(`/api/rcx/config/${fi}/transaction-classification-rule/import`, {});
  }
}
